// export const endpoint = "https://api.napoli.dev.camelot.vote"

export const endpoint: string = process.env.REACT_APP_API_ENDPOINT!;
